import React, { useEffect } from 'react';
import 'magnific-popup';
import $ from 'jquery';
import { Link } from 'react-router-dom'



function Faq({ afterElment }) {
  useEffect(() => {


    /* magnificPopup video view */
    $('.popup-video').magnificPopup({
      type: 'iframe'
    });

  }, [])


  return (

    <section className={afterElment + " faq-bg"}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="faq-img-wrap">
              <img src="img/images/faq_tv.png" className="img-frame" alt="" />
              <img src="img/images/faq_img.png" className="main-img" alt="" />
              <Link to="/https://www.youtube.com/watch?v=XdFfCPK5ycw" className="popup-video" > </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="faq-wrapper">
              <div className="section-title mb-35">
                <h5 className="sub-title">FAQ</h5>
                <h2 className="title">Questions Fréquemment Posées</h2>
              </div>
              <div className="accordion" id="accordionExample">
                {[
                  {
                    id: 'headingOne',
                    collapseId: 'collapseOne',
                    question: "Quel est le délai pour retourner un article ?",
                    answer: "Vous disposez de 14 jours calendaires après réception pour demander un retour via e-mail ou nos réseaux sociaux."
                  },
                  {
                    id: 'headingTwo',
                    collapseId: 'collapseTwo',
                    question: "Quelles sont les conditions pour qu'un retour soit accepté ?",
                    answer: "L'article doit être neuf, non lavé, sans poils ni odeurs, et dans son emballage d'origine."
                  },
                  {
                    id: 'headingThree',
                    collapseId: 'collapseThree',
                    question: "Quels sont les délais de livraison ?",
                    answer: "La livraison prend généralement entre 48 et 72 heures sur toute la Tunisie."
                  },
                  {
                    id: 'headingFour',
                    collapseId: 'collapseFour',
                    question: "Quels sont les moyens de paiement acceptés ?",
                    answer: "Nous acceptons que le paiement à la livraison pour le moment."
                  },
                  {
                    id: 'headingFive',
                    collapseId: 'collapseFive',
                    question: "Mes données personnelles sont-elles protégées ?",
                    answer: "Oui, vos données sont confidentielles et utilisées uniquement pour traiter vos commandes. Elles ne sont jamais vendues à des tiers."
                  }
                ].map((item, index) => (
                  <div className="card" key={index}>
                    <div className="card-header" id={item.id}>
                      <h2 className="mb-0">
                        <button
                          className={`btn btn-link btn-block text-left collapsed`}
                          type="button"
                          data-toggle="collapse"
                          data-target={`#${item.collapseId}`}
                          aria-expanded={index === 0 ? "true" : "false"}
                          aria-controls={item.collapseId}
                        >
                          {item.question}
                        </button>
                      </h2>
                    </div>
                    <div
                      id={item.collapseId}
                      className={`collapse`}
                      aria-labelledby={item.id}
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        {item.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faq-shape"><img src="img/images/faq_shape.png" alt="" /></div>
    </section>
  )
}

export default Faq;
